import React from 'react';
import { PrimaryButton } from '../../components/ui-toolkit/buttons.js';

import './job.scss';

const JobCard = ({
	title, id = '', formatMessage = '',
}) => (
	<section
		className="col-lg-12 col-md-12 col-sm-12 col-xs-12"
	>
		<div className="job">
			<div className="row">
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 job-title">
					{title}
				</div>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 job-button">
					<PrimaryButton className="btn-color-theme-2" to={`/careers/${id}`}>
						{formatMessage({ id: 'careers.button-short' })}
					</PrimaryButton>
				</div>
			</div>
		</div>

	</section>
);

export default JobCard;
